import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_ESUS,
    useChartsData
} from '../../../Common/Filters/useChartsData';

export const ProceduresChartsDataContext = createContext();

const ProceduresChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_ESUS.PRODUCTION_PROCEDURES,
            url: 'governanceroom/esus/production/procedures'
        },
        {
            year: filters.ano.value,
            month: filters.competencia.map((competencia) => competencia.value),
            location: filters.unidade.value,
            procedure_group: filters.procedure_group.map((item) => item.value),
            procedure_subgroup: filters.procedure_subgroup.map(
                (item) => item.value
            ),
            procedures: filters.procedures.map((item) => item.value),
            city: filters.cidade?.governance_room_geo_city_id,
        }
    );

    const chartData = data
        ? {
              annualEvolutionProcedures: data?.annualEvolutionProcedures ?? [],
              evolutionByProcedures: data?.evolutionByProcedures ?? []
          }
        : {
              annualEvolutionProcedures: [],
              evolutionByProcedures: []
          };

    return (
        <ProceduresChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </ProceduresChartsDataContext.Provider>
    );
};

export default ProceduresChartsDataProvider;
